import { render, staticRenderFns } from "./comp_ProductImagesCarousel.vue?vue&type=template&id=3bcba08c&scoped=true&"
import script from "./comp_ProductImagesCarousel.vue?vue&type=script&lang=js&"
export * from "./comp_ProductImagesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductImagesCarousel.vue?vue&type=style&index=0&id=3bcba08c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcba08c",
  null
  
)

export default component.exports